import { render, staticRenderFns } from "./jiancebaogao.vue?vue&type=template&id=1d5d34eb&scoped=true&"
import script from "./jiancebaogao.vue?vue&type=script&lang=js&"
export * from "./jiancebaogao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5d34eb",
  null
  
)

export default component.exports